import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faHourglassHalf } from "@fortawesome/free-solid-svg-icons"

export const HourglassHalf = (props) => {
  return <FontAwesomeIcon faIcon={faHourglassHalf} {...props} />
}
